<template>
  <div id="app" :class="['app ' + $route.name]">
    <transition name="fade">
      <div id="page" class="page" v-if="pageLoaded">
        <transition name="fade">
          <Menu
            v-if="menuVisible"
            :userProfile="userProfile"
            @openTopUpModal="openTopUpFromMenu"
          />
        </transition>
        <div
          class="mob menu-icon"
          @click="toggleMenu"
          :class="{ active: menuVisible }"
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="header-container">
          <Header
            :cartContents="cartContents"
            :searchedProductText="searchedProductText"
            :userProfile="userProfile"
            @openSaleSkinModal="openSaleSkinModal"
            @openTopUpModal="openTopUpModal"
            @searchSubmit="searchSubmit"
            @logout="logout"
            v-if="
              isAuth ||
              (!isAuth && $route.name != 'Profile' && $route.name != 'Cart')
            "
          />
        </div>
        <router-view
          @openOfferDetailsModal="openOfferDetailsModal"
          @openAcceptOfferModal="openAcceptOfferModal"
          @formatDate="formatDate"
          :searchedProductText="searchedProductText"
          :addToCartChosenItem="addToCartChosenItem"
          :currency="currency"
          @addToCart="addToCart"
          @goToProduct="goToProduct"
          @login="login"
          @forgotPass="forgotPass"
          @registration="registration"
          :productCategory="productCategory"
          @searchSubmit="searchSubmit"
        />
        <div class="footer-container">
          <Footer
            v-if="
              isAuth ||
              (!isAuth && $route.name != 'Profile' && $route.name != 'Cart')
            "
          />
        </div>
        <transition name="fade">
          <ProductModal
            v-if="productModalIsVisible"
            @closeProductModal="closeProductModal"
            :productView="productView"
            :similarProducts="similarProducts"
          />
        </transition>
        <transition name="fade">
          <OfferDetailsModal
            v-if="offerDetailsModalIsVisible"
            @closeOfferDetailsModal="closeOfferDetailsModal"
            @actionCompleted="handleOfferAction"
            @openAcceptOfferModal="openAcceptOfferModal"
            @setError="setError"
            :orderToView="orderToView"
          />
        </transition>
        <transition name="fade">
          <SaleSkinModal
            v-if="saleSkinModalIsVisible"
            @createOffer="createOffer"
            @closeSaleSkinModal="closeSaleSkinModal"
          />
        </transition>

        <transition name="fade">
          <AcceptOfferModal
            v-if="acceptOfferModalIsVisible"
            @setError="setError"
            @closeAcceptOfferModal="closeAcceptOfferModal"
            :orderToView="orderToView"
          />
        </transition>

        <transition name="fade">
          <TopUpModal
            v-if="topUpModalIsVisible"
            :initialAmount="topUpAmount"
            :profile="userProfile"
            @close="closeTopUpModal"
          />
        </transition>

        <!--        <div class="modal modal-overlay" v-if="cookesModalIsVisible">-->
        <!--          <div class="cookies-modal">-->
        <!--            <div class="title">We Use Cookies</div>-->
        <!--            <div class="desc chekbox-label">-->
        <!--              Hey there! To provide you with the best experience, our website-->
        <!--              uses cookies. Essential cookies are always active to ensure site-->
        <!--              functionality. We also utilize other cookies for different-->
        <!--              purposes, which you can manage. For more information, see our-->
        <!--              <router-link :to="cookiesLink" class="title" v-if="cookiesLink">-->
        <!--                Cookie Policy-->
        <!--              </router-link>-->
        <!--              .-->
        <!--            </div>-->
        <!--            <button class="button blue" @click="acceptCookies">-->
        <!--              <span>Proceed</span>-->
        <!--            </button>-->
        <!--          </div>-->
        <!--        </div>-->
        <cookie-modal :text-page-list="staticPages"></cookie-modal>
      </div>
    </transition>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Menu from "./components/Menu.vue";
import ProductModal from "./components/ProductModal.vue";
import Footer from "./components/Footer.vue";
import OfferDetailsModal from "./components/OfferDetailsModal.vue";
import SaleSkinModal from "./components/SaleSkinModal.vue";
import { loadScriptsFromString } from "@/utils/load_scripts";
import { mapActions, mapGetters } from "vuex";
import CookieModal from "./components/CookieModal.vue";
import AcceptOfferModal from "./components/AcceptOfferModal.vue";
import TopUpModal from "./components/TopUpModal.vue";
// import staticPages from "./store/modules/staticPages";
// import staticPages from "./store/modules/staticPages";
// import staticPages from "@/store/modules/staticPages";
// import staticPages from "./store/modules/staticPages";

export default {
  name: "app",
  components: {
    CookieModal,
    Header,
    Menu,
    Footer,
    OfferDetailsModal,
    SaleSkinModal,
    ProductModal,
    AcceptOfferModal,
    TopUpModal,
  },
  data: function () {
    return {
      pageLoaded: false,
      menuVisible: false,
      offerDetailsModalIsVisible: false,
      saleSkinModalIsVisible: false,
      nav: [
        {
          title: "Home",
          link: "/home",
        },
        {
          title: "Shop",
          link: "/product-list/all",
        },
        {
          title: "Fresh Offers",
          link: "/fresh",
        },
        {
          title: "Discount Store",
          link: "/sale",
        },
      ],
      isAuth: false,
      error: "",
      successMessage: "",
      orderHistory: [],
      offerHistory: [],
      orderToView: [],
      addToCartChosenItem: "",
      newArrivals: [],
      recommendedProducts: [],
      saleProducts: [],
      cartContents: [],
      totalSum: "0.00",
      totalFiat: null,
      totalFiatCurrency: "",
      cartUsesInternalCurrency: false,
      productPageItem: "",
      similarProducts: [],
      imgDomain: "",
      appDomain: "",
      productCategory: "",
      hostname: "",
      footerRequisites: "",
      footerSupportEmail: "",
      footerCopyright: "",
      categoryOptions: [],
      paymentMethods: [],
      cookesModalIsVisible: false,
      socialLinks: [],
      searchedProductText: "",
      productModalIsVisible: false,
      productView: {},
      acceptOfferModalIsVisible: false,
      payoutSettings: null,
      payoutMethods: { card: true, sepa: true },
      offerEnabled: false,
      userProfile: {},
      topUpModalIsVisible: false,
      topUpAmount: "",
    };
  },
  watch: {
    currency() {
      this.refreshSettings().catch((error) => {
        console.error("Error refreshing settings:", error);
      });
      this.getNewArrivals();
      this.getSale();
      this.getRecommended();

      if (this.isAuth) {
        this.orderHistory = [];
        this.offerHistory = [];
        this.cartContents = "";
        this.totalSum = "";
        this.totalFiat = null;
        this.totalFiatCurrency = "";
        this.cartUsesInternalCurrency = false;
        this.getUserProfile();
        this.getOrderHistory();
        this.getOfferHistory();
        this.getCartContents();
      }
    },
    $route() {
      window.scrollTo(0, 0);
      this.closeMenu();
      if (this.isAuth) {
        this.getOfferHistory();
        this.getOrderHistory();
      }
      this.productCategory = this.$route.params.id;
      this.handleProductIdRouteChange();
    },
  },
  methods: {
    handleProductIdRouteChange() {
      if (!this.$route || !this.$route.query || !this.$route.query.productId) {
        return;
      }

      if (this.$route.name !== "ProductListPage") {
        return;
      }

      const productId = this.$route.query.productId;

      this.$http
        .get(process.env.VUE_APP_API + "items/" + productId, {
          params: { currency: this.currency },
        })
        .then((res) => {
          this.productView = res.data.payload;
          this.similarProducts = res.data.payload.similar;
          this.productModalIsVisible = true;
          document.body.style.overflow = "hidden";
        })
        .catch(() => {})
        .then(() => {
          this.cleanupProductIdQuery();
        });
    },
    cleanupProductIdQuery() {
      if (!this.$route || !this.$route.query || !this.$route.query.productId) {
        return;
      }

      const query = { ...this.$route.query };
      delete query.productId;

      this.$router.replace({ path: this.$route.path, query });
    },
    setError(error) {
      this.error = error;
    },
    handleOfferAction() {
      this.getOfferHistory();
    },
    openAcceptOfferModal(item) {
      this.orderToView = item;
      this.acceptOfferModalIsVisible = true;
      this.closeOfferDetails();
    },
    closeAcceptOfferModal() {
      this.acceptOfferModalIsVisible = false;
      this.clearError();
      this.orderToView = {};
    },
    openTopUpModal(amount) {
      if (document.activeElement && document.activeElement.blur) {
        document.activeElement.blur();
      }
      if (window.$) {
        try {
          window.$(".select2-hidden-accessible").select2("close");
          window.$(document).trigger({
            type: "keydown",
            which: 27,
            keyCode: 27,
          });
        } catch (e) {
          console.log(e);
        }
      }
      this.topUpAmount = amount || "";
      this.topUpModalIsVisible = true;
      document.body.style.overflow = "hidden";
    },
    openTopUpFromMenu() {
      this.closeMenu();
      this.openTopUpModal();
    },
    closeTopUpModal() {
      this.topUpModalIsVisible = false;
      document.body.style.overflow = "auto";
      this.topUpAmount = "";
    },
    refreshUserProfile() {
      return this.getUserProfile();
    },
    ...mapActions("staticPages", ["fetchPages"]),
    closeProductModal() {
      let self = this;
      document.body.style.overflow = "unset";
      this.productView = {};
      this.similarProducts = [];
      setTimeout(() => {
        self.productModalIsVisible = false;
      }, 100);
    },
    openProductModal(item) {
      this.productModalIsVisible = true;
      this.productView = item;
      this.getProductPageContent(item.id);
      document.body.style.overflow = "hidden";
    },
    clearSearch() {
      this.searchedProductText = "";
    },
    searchSubmit(text) {
      this.searchedProductText = text;
      if (this.$route.name != "ProductListPage") {
        this.$router.push({ path: "/product-list/all" });
      }
    },
    getSocialLinks() {
      return this.$http
        .get(process.env.VUE_APP_API + "social-links")
        .then((res) => {
          this.socialLinks = res.data.payload;
        });
    },
    cookiesModal() {
      const cookiesAccepted = localStorage.getItem("cookiesAccepted");

      if (!cookiesAccepted) {
        this.cookesModalIsVisible = true;
      }
    },
    declineCookies() {
      this.cookesModalIsVisible = false;
    },
    acceptCookies() {
      localStorage.setItem("cookiesAccepted", "true");
      this.cookesModalIsVisible = false;
    },
    setProductCategory(category) {
      this.productCategory = category;
      if (category) {
        this.$router.push({ path: "/product-list/" + category });
      }
    },
    getCategoryOptions() {
      this.$http
        .get(process.env.VUE_APP_API + "items/filter-data")
        .then((res) => {
          let newCategories = res.data.payload.types;

          const specialOrder = [
            "Knife",
            "Rifle",
            "Machinegun",
            "Shotgun",
            "Sniper Rifle",
            "SMG",
            "Pistol",
          ];

          // Swap their positions
          const available = newCategories.map((c) => String(c).toLowerCase());
          const reorderedItems = specialOrder.filter((item) =>
            available.includes(item.toLowerCase())
          );

          this.categoryOptions = reorderedItems;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignIn();
          }
        });
    },
    getDomainName(hostName) {
      return hostName.substring(
        hostName.lastIndexOf(".", hostName.lastIndexOf(".") - 1) + 1
      );
    },
    closeMenu() {
      this.menuVisible = false;
      document.body.style.overflow = "auto";
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
      window.scrollTo(0, 0);
      if (this.menuVisible) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }
    },
    menuHeight() {
      const doc = document.documentElement;
      doc.style.setProperty("--vh", `${window.innerHeight * 0.01}px`);
    },
    clearError() {
      this.error = "";
    },
    handleOfferDeclined() {
      // Refresh offer history after decline
      this.getOfferHistory();
    },
    openOfferDetailsModal(item) {
      this.orderToView = item;
      this.offerDetailsModalIsVisible = true;
    },
    closeOfferDetails() {
      this.offerDetailsModalIsVisible = false;
    },
    closeOfferDetailsModal() {
      this.offerDetailsModalIsVisible = false;
      this.orderToView = {};
    },
    openSaleSkinModal() {
      this.saleSkinModalIsVisible = true;
    },
    closeSaleSkinModal() {
      this.error = null
      this.saleSkinModalIsVisible = false;
    },
    login(data) {
      this.$http
        .post(process.env.VUE_APP_API + "login", data)
        .then((res) => {
          if (res.data.status == "OK") {
            this.isAuth = true;
            this.getUserProfile();
            this.getOfferHistory();
            this.getOrderHistory();
            this.getCartContents();
            this.$router.push({ path: "/profile" });
          } else {
            this.error = res.data.message;
          }
        })
        .catch((res) => {
          this.error = res.response.data.message;
        });
    },
    forgotPass(data) {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_API + "user/reset-password", data)
        .then((res) => {
          if (res.data.status == "OK") {
            this.successMessage = "Success";
            this.error = "";
            setTimeout(() => {
              self.successMessage = "";
            }, 2000);
          } else {
            this.error = res.response.data.message;
          }
        })
        .catch((error) => {
          this.error = error.response.data.message;
        });
    },
    registration(data) {
      let self = this;
      if (data.password !== data.passConfirm) {
        this.error = "Password confirmation failed!";
      } else {
        this.$http
          .post(process.env.VUE_APP_API + "register", data)
          .then((res) => {
            if (res.data.status == "OK") {
              this.clearError();
              self.isAuth = true;
              self.getUserProfile();
              self.$router.push({ path: "/profile" });
            } else {
              this.error = res.data.message;
            }
          })
          .catch((res) => {
            this.error = res.response.data.message;
          });
      }
    },
    logout() {
      this.$http
        .post(process.env.VUE_APP_API + "logout")
        .then(() => {
          if (this.$route.name != "Home") {
            this.$router.push({ path: "/" });
          }
          this.isAuth = false;
          this.userProfile = {};
          this.totalFiat = null;
          this.totalFiatCurrency = "";
          this.cartUsesInternalCurrency = false;
          this.$router.push({ path: "/" });
        })
        .catch((res) => {
          if (res.response.status === 401) {
            console.log(res);
          }
        });
    },
    getOrderHistory() {
      this.$http
        .get(
          process.env.VUE_APP_API + "purchase/history?currency=" + this.currency
        )
        .then((res) => {
          console.log(res);
          this.orderHistory = res.data.payload;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.openSignIn();
          }
        });
    },
    createOffer(data) {
      this.$http
        .post(process.env.VUE_APP_API + "offer/create", data)
        .then((res) => {
          if (res.data.status == "OK") {
            this.clearError();
            this.closeSaleSkinModal();
            this.$router.push({ path: "/offer-sent-succes" });
          } else {
            // this.error = res.data.message
            if (res.response.data.errors) {
              const firstErrors = {};
              for (const key in res.response.data.errors) {
                if (
                  res.response.data.errors.hasOwnProperty(key) &&
                  Array.isArray(res.response.data.errors[key]) &&
                  res.response.data.errors[key].length > 0
                ) {
                  firstErrors[key] = res.response.data.errors[key][0];
                  this.$emit("setError", firstErrors[key]);
                }
              }
            } else {
              this.$emit("setError", res.response.data.message);
            }
          }
        })
        .catch((res) => {
          if (res.response.data.errors) {
            const firstErrors = {};
            for (const key in res.response.data.errors) {
              if (
                res.response.data.errors.hasOwnProperty(key) &&
                Array.isArray(res.response.data.errors[key]) &&
                res.response.data.errors[key].length > 0
              ) {
                firstErrors[key] = res.response.data.errors[key][0];
                // this.$emit('setError', firstErrors[key]);
                this.error = firstErrors[key];
              }
            }
          } else {
            this.error = res.response.data.message;
          }
          // this.error = res.response.data.message;
        });
    },
    getOfferHistory() {
      this.$http
        .get(
          process.env.VUE_APP_API + "offer/history?currency=" + this.currency
        )
        .then((res) => {
          console.log(res);
          this.offerHistory = res.data.payload;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.openSignIn();
          }
        });
    },
    formatDate(num) {
      let objectDate = new Date(num * 1000);
      let day = objectDate.getDate();
      if (day < 10) {
        day = "0" + day;
      }
      let month = objectDate.getMonth() + 1;
      if (month < 10) {
        month = `0${month}`;
      }
      let year = objectDate.getFullYear();

      function padTo2Digits(x) {
        return String(x).padStart(2, "0");
      }
      let hoursAndMinutes =
        padTo2Digits(objectDate.getHours()) +
        ":" +
        padTo2Digits(objectDate.getMinutes());
      let format = day + "." + month + "." + year + " " + hoursAndMinutes;

      return format;
    },
    removeOneFromCart(item, id) {
      let self = this;

      let cartItem = {
        id: id,
        count: "1",
      };
      if (item.count > 1) {
        cartItem = {
          id: id,
          count: item.count - 1,
        };
      }
      this.$http
        .post(process.env.VUE_APP_API + "cart/add", cartItem)
        .then((res) => {
          self.cartContents = res.data.cart;
          this.getCartContents();
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.openSignIn();
          }
        });
    },
    removeFromCart(item, id) {
      let self = this;

      let cartItem = {
        id: id,
      };

      this.$http
        .post(process.env.VUE_APP_API + "cart/remove", cartItem)
        .then((res) => {
          self.cartContents = res.data.cart;
          this.getCartContents();
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.openSignIn();
          }
        });
    },
    addToCart(item, id) {
      if (!this.isAuth) {
        this.closeProductModal();
        this.openSignIn();
      } else {
        let self = this;

        let cartItem = {
          id: id,
          count: 1,
        };

        for (var i = 0; i < this.cartContents.length; i++) {
          if (this.cartContents[i].item_id == id) {
            let cartItemCount = this.cartContents[i].count;
            cartItem = {
              id: id,
              count: cartItemCount + 1,
            };
            break;
          }
        }

        this.$http
          .post(process.env.VUE_APP_API + "cart/add", cartItem)
          .then((res) => {
            this.getCartContents();
            self.addToCartChosenItem = cartItem.id;
            self.cartContents = res.data.cart;
            setTimeout(() => {
              self.addToCartChosenItem = "";
            }, 2000);
          })
          .catch((res) => {
            if (res.response.status === 401) {
              this.openSignIn();
            }
          });
      }
    },
    getNewArrivals() {
      this.$http
        .get(process.env.VUE_APP_API + "items/list?&currency=" + this.currency)
        .then((res) => {
          this.newArrivals = res.data.payload;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.openSignIn();
          }
        });
    },
    getRecommended() {
      this.$http
        .get(
          process.env.VUE_APP_API +
            "items/recommended?currency=" +
            this.currency
        )
        .then((res) => {
          this.recommendedProducts = res.data.payload;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.openSignIn();
          }
        });
    },
    getSale() {
      this.$http
        .get(
          process.env.VUE_APP_API +
            "items/list?sale=true&currency=" +
            this.currency
        )
        .then((res) => {
          this.saleProducts = res.data.payload;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.openSignIn();
          }
        });
    },
    getCartContents() {
      this.$http
        .get(
          process.env.VUE_APP_API + "cart/contents?currency=" + this.currency
        )
        .then((res) => {
          this.cartContents = res.data.cart;
          this.cartUsesInternalCurrency = Boolean(res.data.is_internal_currency);
          this.totalFiat =
            res.data.total_fiat !== undefined && res.data.total_fiat !== null
              ? parseFloat(res.data.total_fiat).toFixed(2)
              : null;
          this.totalFiatCurrency = res.data.fiat_currency || res.data.currency || "";

          if (res.data.is_internal_currency && res.data.total_internal !== null) {
            this.totalSum = parseFloat(res.data.total_internal).toFixed(2);
          } else if (res.data.total !== undefined) {
            this.totalSum = parseFloat(res.data.total).toFixed(2);
          } else {
            let total = 0;
            for (let i in this.cartContents) {
              let newPrice;
              if (this.cartContents[i].count > 1) {
                newPrice =
                  this.cartContents[i].count *
                  parseFloat(this.cartContents[i].item.price);
              } else {
                newPrice = parseFloat(this.cartContents[i].item.price);
              }
              total += newPrice;
            }
            this.totalSum = total.toFixed(2);
          }
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.openSignIn();
          }
        });
    },
    goToProduct(item) {
      this.openProductModal(item);
    },
    getProductPageContent(id) {
      this.productPageItem = "";
      this.similarProducts = [];
      this.$http
        .get(process.env.VUE_APP_API + "items/" + id, {
          params: { currency: this.currency },
        })
        .then((res) => {
          this.productPageItem = res.data.payload;
          this.similarProducts = res.data.payload.similar;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.openSignIn();
          }
        });
    },
    openSignIn() {
      this.$router.push({ path: "/login" });
    },
    openSignUp() {
      this.$router.push({ path: "/registration" });
    },
    openRecover() {
      this.$router.push({ path: "/recover" });
    },
    getUserProfile() {
      if (!this.isAuth) return Promise.resolve();
      return this.$http
        .get(process.env.VUE_APP_API + "user/profile", {
          params: { currency: this.currency },
        })
        .then((res) => {
          this.userProfile = res.data || {};
        })
        .catch((res) => {
          if (res.response && res.response.status === 401) {
            this.openSignIn();
          }
        });
    },
    async refreshSettings() {
      const payload = await this.fetchSettings();

      this.paymentMethods = payload.payment_methods || [];
      this.footerRequisites = payload.requisites;
      this.footerSupportEmail = payload.support_email;
      this.footerCopyright = payload.copyright;
      this.payoutSettings = payload.payout_settings;
      if (payload.payout_methods) {
        this.payoutMethods = payload.payout_methods;
      }
      this.offerEnabled = payload.offer_enabled;
      return payload;
    },
    async getGoogleTagManagerSnippet() {
      try {
        const payload = await this.refreshSettings();

        const snippet = payload.google_tag;
        if (snippet) {
          loadScriptsFromString(snippet).catch((error) => {
            console.error("Error loading Google Tag snippet:", error);
          });
        }

        const chatbotScript = payload.chatbot_script;
        console.log("chatbot_script from settings:", chatbotScript);
        if (chatbotScript) {
          await loadScriptsFromString(chatbotScript);
        }
      } catch (error) {
        console.error("Error fetching Google Tag Manager snippet:", error);
      }
    },
    ...mapActions("app", ["fetchCurrencies", "fetchSettings"]),
  },
  mounted: async function () {
    await this.fetchCurrencies();
    this.hostname = this.getDomainName(window.location.hostname);
    this.productCategory = this.$route.params.id;
    this.appDomain = process.env.VUE_APP_DOMAIN;
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
    let self = this;
    window.addEventListener("resize", self.menuHeight);
    self.menuHeight();
    this.getSocialLinks();

    await self.getGoogleTagManagerSnippet();
    this.pageLoaded = true;

    self.$http
      .get(process.env.VUE_APP_API + "is-auth")
      .then((res) => {
        console.log("auth: " + res.data.authenticated);
        self.isAuth = res.data.authenticated;

        if (res.data.authenticated) {
          self.getUserProfile();
          self.getOfferHistory();
          self.getOrderHistory();
          self.getCartContents();
        }
      })
      .catch((res) => {
        if (res.response.status === 401) {
          this.openSignIn();
        }
      });
    this.cookiesModal();
    this.getCategoryOptions();
    this.getSale();
    this.getRecommended();
    this.getNewArrivals();
    // this.getTextPages();
    await this.fetchPages();
    this.handleProductIdRouteChange();
  },
  computed: {
    ...mapGetters("app", ["currency"]),
    ...mapGetters("staticPages", ["getCookiePage", "staticPages"]),
    pages() {
      return this.staticPages;
    },
    cookiesLink() {
      const page = this.getCookiePage;
      console.log(page);

      return page
        ? { name: "TextPage", params: { identifier: page.slug } }
        : null;
    },
  },
};
</script>
